/** Course filter values — `all` plus the four tracked courses (tz.md §3.1). */
export const COURSE_OPTIONS = [
  'all',
  'Cybersecurity',
  'DevOps',
  'Data Science',
  'Python',
] as const;

export const GRANULARITY_OPTIONS = ['day', 'week', 'month'] as const;

export type Granularity = typeof GRANULARITY_OPTIONS[number];

export type DatePresetId = '30d' | '90d' | '12m' | 'all';

/** Quick date-range presets shown alongside the custom range picker. */
export const DATE_PRESETS: { id: DatePresetId }[] = [
  { id: '30d' },
  { id: '90d' },
  { id: '12m' },
  { id: 'all' },
];

export const DEFAULT_DATE_PRESET: DatePresetId = '12m';

/** Series / KPI accent colors — ported from docs/pandadoc-dashboard/index.html. */
export const COLORS = {
  students: '#4f46e5',
  trainers: '#0891b2',
  dofin: '#d97706',
  tts: '#059669',
  byCourse: '#10b981',
  signed: '#16a34a',
  active: '#f59e0b',
  lost: '#dc2626',
  grid: '#f1f5f9',
  axis: '#64748b',
} as const;
